import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { LocaleHandler } from '@core/handler/locale.handler';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { OverlayPage } from './features/overlay/overlay-page/overlay-page.component';
import { WattsonComponent } from './features/wattson/wattson.component';

@Component({
  selector: 'crm-root',
  imports: [RouterOutlet, MatIconModule, OverlayPage, WattsonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('cr-management-frontend');

  private readonly icons = inject(MatIconRegistry);

  private translate = inject(TranslateService);

  constructor() {
    inject(LocaleHandler);

    this.icons.setDefaultFontSetClass('material-symbols-outlined');

    this.translate.addLangs(environment.I18N_CONFIG.supportedLocales);
    this.translate.setFallbackLang(environment.I18N_CONFIG.defaultLocale);
    this.translate.use(environment.I18N_CONFIG.appLocale);
  }
}
